export default () => {
    return (
        <>
            <div className="h3">You are not authorised for the selected action.</div>
        </>
    );
};
